"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const MailingAddressToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: 'i', info: 'Please enter your personal address. This information is used' +
        " to verify your identity. Once you are registered as a user, you'll be able to use your business" +
        ' information to create a Member and start managing your works.' }));
exports.default = MailingAddressToolTip;
